<template>
    <div class="condition-container" v-show="loaded">
        <inner-children-renderer v-if="_child" :children="_child" />
    </div>
</template>

<script>
import Vue from 'vue';

const {
    plugins: { ComplexComp },
    common: {
        env: { isPreRender }
    },
    store: { variable }
} = require('@futuweb/fego-render');

import ChildItem from '../children/item/render/index.vue';
import { CHILD } from '../constant';

import { runRule } from '../rule-engine';

export default Vue.extend({
    name: 'condition-container',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],

    props: ['tpl'],

    data() {
        return {
            loaded: false,
            targetId: '',
            v: variable.data,
            loading: false
        };
    },
    watch: {
        v: {
            handler() {
                this.refresh();
            },
            deep: true
        }
    },

    computed: {
        defaultTargetId() {
            // eslint-disable-next-line max-len
            return this.tpl.children.find((c) => c.props?.conditions === 'default' || c.props?.conditions.includes('default'))?.id;
        },
        _child() {
            if (!this.loaded) {
                return null;
            }

            let r = this.tpl.children.find((c) => c?.id === this.targetId);
            if (!r) {
                r = this.tpl.children.find((c) => c?.id === this.defaultTargetId);
            }

            return r;
        }
    },

    async mounted() {
        if (isPreRender) {
            return;
        }
        await this.refresh(true);
        this.loaded = true;
    },

    methods: {
        async refresh(init = false) {
            // 防重复点击
            if (this.loading) {
                return;
            }
            this.loading = true;

            // 保留上一个状态
            const lastTarget = this.targetId;
            let targetId = '';
            try {
                targetId = await this.getStatus();
            } catch (err) {
                console.error('[condition-container] getStatus error: ', err);
            } finally {
                this.loading = false;
            }

            if (!targetId) {
                // 主动刷新的情况下，如果失败，优先取原来状态
                targetId = (!init && lastTarget) || this.defaultTargetId;
            }
            this.targetId = targetId;
        },

        async getStatus() {
            const fegoRule = JSON.parse(window.decodeURIComponent(window._pdData))?.metadata?.rule || [];
            const context = {
                FEGORender: window.FEGORender,
            };
            const result = await runRule(fegoRule, context);
            console.log('[condition-container] runRule result: ', result);
            for (let i = 0; i < this.tpl.children.length; i++) {
                const child = this.tpl.children[i];
                let checkConditions = child.props?.conditions || [];
                if (typeof checkConditions === 'string') {
                    checkConditions = [checkConditions];
                }

                // 判断是否满足条件，conditions为为rule中params的id，只要命中一个即可，即为或的关系
                const isMatch = checkConditions.some((condition) => {
                    return result[condition]?.result === true;
                });
                if (isMatch) {
                    return child.id;
                }
            }
        },
    }
});
</script>

<style lang="less" scoped>
.condition-container {
    height: auto !important;
}
</style>
